import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import renderHTML from "lib/render-html";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3),
      minHeight: 170,
      height: "100%",
      backgroundColor: "transparent",
      border: "none",
      borderRadius: 16,
      position: "relative",
      color: theme.palette.common.white,
      margin: theme.spacing(1, 0),
      [theme.breakpoints.down("xs")]: {
        margin: theme.spacing(2, 0),
      },
    },
    layer: {
      position: "absolute",
      backgroundColor: "#3a8aec8a",
      width: "calc(100% - 24px)",
      height: "100%",
      borderRadius: "16px",
      zIndex: 0,
    },
    border: {
      position: "absolute",
      width: "calc(100%)",
      height: "100%",
      borderRadius: "16px",
      border: `1px solid`,
      borderColor: theme.palette.common.white,
      left: 0,
      top: 0,
      zIndex: 1,
    },
    counter: {
      position: "absolute",
      backgroundColor: theme.palette.secondary.main,
      width: "55px",
      height: "55px",
      borderRadius: "50px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      left: -16,
      top: -16,
      zIndex: 1,
      fontSize: 20,
      fontWeight: 300,
      [theme.breakpoints.down("xs")]: {
        width: "40px",
        height: "40px",
        fontSize: 18,
      },
    },
    contents: {
      position: "inherit",
      paddingTop: theme.spacing(4),
      paddingLeft: theme.spacing(2),
    },
  })
);

type KeyFeatureCardProps = {
  count: number;
  point: string;
};
const KeyFeatureCard: React.FC<KeyFeatureCardProps> = ({ count, point }) => {
  const classes = useStyles();

  return (
    <Paper variant="outlined" className={classes.root}>
      <div className={classes.border} />
      <div className={classes.layer} />
      <div className={classes.counter}>{count}</div>
      <div className={classes.contents}>
        <Typography variant="h3" component="p" paragraph>
          {renderHTML(point)}
        </Typography>
      </div>
    </Paper>
  );
};

export default KeyFeatureCard;
